import * as React from "react";
import s from "./ModalIllioLogo.module.scss";
import cn from "classnames";
import { Link } from "react-router-dom";
import { DEFAULT_LOGO_SOURCE } from "../__pageComponents";
interface IProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ModalIllioLogo = (props: IProps) => {
  return (
    <div {...props} className={cn(s.logoSurround)}>
      <Link to={"/"}>
        <img
          alt={"logo"}
          src={DEFAULT_LOGO_SOURCE}
          className={cn(s.logo, "no-invert")}
        />
      </Link>
    </div>
  );
};

export default ModalIllioLogo;
